import clone from './clone';

const filterTreeNodes = <T extends { children: T[] }>(
    nodes: T[],
    fn: (node: T) => boolean
): T[] =>
    nodes.filter(fn).map(node => {
        const item = clone({
            ...node,
            children: [],
        });

        return {
            ...item,
            children: filterTreeNodes(node.children, fn),
        };
    });

export default filterTreeNodes;
